import React from "react";
import { connect } from "react-redux";
import { wrapper } from "@/store";
import {
  getStaticProps as getStaticPropsMethod,
  getStaticPaths as getStaticPathsMethod,
} from "@gcloud-npm/astro/astro-pages-handler";

import AstroLayout from "@/bit/components/components.astro.astro-layout";

import SPA, { spaGetStaticProps } from "@/pages/[...slug]";
import RouteHandler from "@/bit/core/core.route-handler";
import PageHandler from "@/components/page-handler";
import { PROJECT_URLS } from "@/constants/project-urls";

class Public extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    PageHandler.updatePageProps({ location: PROJECT_URLS.MI_CUENTA });
    RouteHandler.loadPage();
  }
  render() {
    const {
      breadcrumbsProps,
      headerProps,
      seoInfo,
      footerProps,
      orionInfo,
      orionAlias,
      paths,
      context,
    } = this.props;
    return (
      <SPA
        paths={paths}
        context={context}
        headerProps={headerProps}
        seoInfoProps={seoInfo}
        footerProps={footerProps}
        externalPage
      >
        <main>
          <AstroLayout orionInfo={{ ...orionInfo }} orionAlias={orionAlias} />
        </main>
      </SPA>
    );
  }
}

const mapStateToProps = (state) => ({
  context: state.main.context,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Public);

const ASTRO_ROUTE_BASE_PATH = "/mi-cuenta";

export const getStaticPaths = async () =>
  getStaticPathsMethod({
    routeBasePath: ASTRO_ROUTE_BASE_PATH,
    fallback: "blocking",
    includeVersionContextVariants: false,
  });

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  const { store } = data;

  const info = await getStaticPropsMethod(data, {
    routeBasePath: ASTRO_ROUTE_BASE_PATH,
  });

  let spaInfo = {};
  spaInfo = await spaGetStaticProps({ store });

  const allProps2Return = {
    props: {
      ...info.props,
      ...spaInfo.props,
    },
    revalidate: info.revalidate || 1,
  };

  return allProps2Return;
});
